/**
 * AWE nav_click tracking.
 *
 * Two delegated listeners (not one per link): #header-group covers the
 * header, mega menu, mobile drawer, and announcement bar (all siblings
 * inside that wrapper — see layout/theme.liquid); footer.awe-footer covers
 * the footer + bottom bar. Only real <a href> nav links carry
 * data-nav-location (set server-side in Liquid), so drill-in/open toggles
 * (mega-menu hover, drawer <summary> arrows) never match and never fire.
 *
 * Depends on assets/awe-analytics-events.js and window.aweCustomerLoggedIn
 * (set in layout/theme.liquid).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var lastFired = { el: null, time: 0 };

  function getNavDevice() {
    if (window.matchMedia('(min-width: 990px)').matches) return 'desktop';
    if (window.matchMedia('(min-width: 750px)').matches) return 'tablet';
    return 'mobile';
  }

  function getNavDestination(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      return url.origin + url.pathname;
    } catch (e) {
      return link.getAttribute('href') || '';
    }
  }

  function shouldDebounce(link) {
    var now = Date.now();
    if (lastFired.el === link && now - lastFired.time < DEBOUNCE_MS) {
      return true;
    }
    lastFired = { el: link, time: now };
    return false;
  }

  function trackNavClick(link) {
    if (!link || shouldDebounce(link)) return;

    window.aweFireGA4Event(
      'nav_click',
      {
        nav_location: link.dataset.navLocation || '',
        nav_label: link.dataset.navLabel || link.textContent.trim(),
        nav_parent: link.dataset.navParent || '',
        nav_depth: parseInt(link.dataset.navDepth, 10) || 1,
        nav_position: parseInt(link.dataset.navPosition, 10) || 0,
        nav_destination: getNavDestination(link),
        nav_device: getNavDevice(),
        nav_logged_in: !!window.aweCustomerLoggedIn,
      },
      { beacon: true }
    );
  }

  function onClick(event) {
    var link = event.target.closest('a[data-nav-location]');
    if (link) trackNavClick(link);
  }

  function onKeydown(event) {
    if (event.key !== 'Enter') return;
    var link = event.target.closest('a[data-nav-location]');
    if (link) trackNavClick(link);
  }

  function attach(root) {
    if (!root || root.__aweNavTrackingAttached) return;
    root.__aweNavTrackingAttached = true;
    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
  }

  function init() {
    attach(document.getElementById('header-group'));
    attach(document.querySelector('footer.awe-footer'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
